module.exports = __webpack_public_path__ + "static/13-0d4bfc33e4222c1d0bff740be4ef2d56.mp4";